import { Action, createReducer, on } from '@ngrx/store';
import {
    setAssignedToMeFilter,
    setLargeDocsOnlyFilter,
    setPostedByCandidatedFilter,
    setPostedByVendorFilter
} from 'src/app/compliance/store/actions/posted-documents-grouped.actions';
import { PostedDocumentsGroupedState } from 'src/app/compliance/store/state/posted-documents-grouped.state';

const initialState: PostedDocumentsGroupedState = {
    groupedAssignedToMeFilter: false,
    groupedPostedByCandidateFilter: false,
    groupedPostedByVendorFilter: false,
    largeDocsOnlyFilter: false
};

const reducer = createReducer(
    initialState,

    on(setAssignedToMeFilter, (state, action) => ({
        ...state,
        groupedAssignedToMeFilter: action.assignedToMeFilter
    })),

    on(setPostedByCandidatedFilter, (state, action) => ({
        ...state,
        groupedPostedByCandidateFilter: action.postedByCandidateFilter
    })),

    on(setPostedByVendorFilter, (state, action) => ({
        ...state,
        groupedPostedByVendorFilter: action.postedByVendorFilter
    })),

    on(setLargeDocsOnlyFilter, (state, action) => ({
        ...state,
        largeDocsOnlyFilter: action.largeDocsOnlyFilter
    }))
);

export function postedGroupedDocumentsReducer(state: PostedDocumentsGroupedState | undefined, action: Action) {
    return reducer(state, action);
}
